import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import "./navbar.css";
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { GrLanguage } from 'react-icons/gr';
import NavbarLogo from "../../assets/pdi-logo3.png";
import previewVideo from "../../assets/preview-video.mp4"
import PreviewModal from './PreviewModal';
import { useLanguage } from '../../context/LanguageContext';
import LanguageDropdown from './LanguageDropdown';

const Navbar = ({ direction, ...args }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const mobileMenuRef = useRef(null);
    const { t, changeLanguage } = useLanguage();

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !event.target.closest('button[aria-label="menu"]')) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const toggleMenu = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);

    return (
        <nav className={`navbar-container  flex justify-around items-center relative navbar ${isScrolled ? 'fixed top-0 left-0 w-full z-50' : ''}`}>
            <div className='md:grid grid-cols-7 md:w-full items-center justify-around navbar-container2'>
                <div className="col-span-2 text-white text-xl flex justify-start navbar-logo-container">

                    <Link className="navbar-logo-link w-full flex items-center justify-start" to="/">
                        <img src={NavbarLogo} alt="Logo" className="navbar-logo" />
                    </Link>

                </div>
                <div className="col-span-3 navbar-link-container hidden md:flex justify-center items-center gap-12">
                    <Link className="navbar-link" to="/">{t("home")}</Link>
                    <Link className="navbar-link" to="/products">{t("products")}</Link>
                    <Link className="navbar-link" to="/about">{t("about")}</Link>
                    <Link className="navbar-link" to="/contact">{t("contact")}</Link>
                    <Link className="navbar-link" to="/faq">{t("faq")}</Link>
                </div>
                <div className='col-span-2 flex justify-end items-center gap-4 language-dropdown-container'>
                    {/* <Dropdown className='language-dropdown' isOpen={dropdownOpen} toggle={toggle} direction={direction}>
                        <DropdownToggle caret className='flex items-center language-dropdown-button'><GrLanguage />&nbsp;</DropdownToggle>
                        <DropdownMenu className='language-dropdown-menu' {...args}>
                            <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("tr")}>Türkçe</DropdownItem>
                            <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("en")}>English</DropdownItem>
                        </DropdownMenu>
                    </Dropdown> */}
                    <LanguageDropdown />

                    {/* <Link className="navbar-try-link " id='navbar-try-button' target="_blank" to="/sign-up">Demoyu Önizleyin</Link> */}

                    <button type="button" class="btn navbar-try-link" data-bs-toggle="modal" data-bs-target="#previewModal">
                        {t("demo-preview")}
                    </button>

                </div>
            </div>

            <div className="md:hidden flex gap-2">

                {/* <Dropdown className='language-dropdown' isOpen={dropdownOpen} toggle={toggle} direction={direction}>
                        <DropdownToggle caret className='flex items-center language-dropdown-button'><GrLanguage />&nbsp;</DropdownToggle>
                        <DropdownMenu className='language-dropdown-menu' {...args}>
                            <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("tr")}>Türkçe</DropdownItem>
                            <DropdownItem className="language-dropdown-item" onClick={() => changeLanguage("en")}>English</DropdownItem>
                        </DropdownMenu>
                    </Dropdown> */}
                <LanguageDropdown />

                <button onClick={toggleMenu} className="text-black focus:outline-none" aria-label="menu">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div ref={mobileMenuRef} className="absolute top-[50px] left-0  p-4 flex flex-col bg-white space-y-2 md:hidden mobile-navbar-page">
                    <Link onClick={() => setIsOpen(false)} className=" " to="/">{t("home")}</Link>
                    <Link onClick={() => setIsOpen(false)} className=" " to="/products">{t("products")}</Link>
                    <Link onClick={() => setIsOpen(false)} className=" " to="/about">{t("about")}</Link>
                    <Link onClick={() => setIsOpen(false)} className=" " to="/contact">{t("contact")}</Link>
                    <Link onClick={() => setIsOpen(false)} className=" " to="/faq">{t("faq")}</Link>

                    <button type="button" class="btn navbar-try-link" data-bs-toggle="modal" data-bs-target="#previewModal">
                        {t("demo-preview")}
                    </button>
                </div>
            )}

        </nav>
    );
};

export default Navbar;
